import {createContext} from "react";

export interface StepsContextProps {
    goNext: (withAnimation?: boolean) => void;
    goBack: () => void;
    currentStep: number;
    goToStep: (nextStep: number) => void;
}

export const StepsContext = createContext<StepsContextProps>({
    goNext: (withAnimation?: boolean) => null,
    goBack: () => null,
    currentStep: 1,
    goToStep: (nextStep: number) => null,
});